import React from "react";
import IndividualCustomer from "@commons/customer-management/individual-customer";

const CustomerDetails = () => {
  return <IndividualCustomer />;
};

export default CustomerDetails;
